// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-frequency .time-input[data-v-0f3d8812]{font-size:14px;padding-top:6px}.error[data-v-0f3d8812]{font-size:14px;color:#ff5b61;margin-bottom:3px}", ""]);
// Exports
module.exports = exports;
